export const returnAirlineLogoUrl = (airlineCode: string) =>
  `https://mevuelo.com.uy/assets/airlines/${airlineCode}.png`;
